import { Button } from "antd";
import MainLayout from "../../layout/MainLayout";
import { PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import QAModel from "../../components/models/QAModel";
import { useToast } from "../../utils/Toast";
import useExpiredToken from "../../utils/useExpiredToken";
import { assignPatch, assignPost, deleteApi, getApi, useApiCall } from "../../services/api";
import { useSelector } from "react-redux";
import { formatDate } from "../../utils/DateFormat";
import { getManageQaTableColumns } from "../../utils/ShowData";
import { processEncryptedResponse } from "../../utils/ResponseDecreypt";
import { filterDataFunc, roleIds,roleNames } from "../../constant";
import DeleteModal from "../../components/models/DeleteModal";
import DataTable from "../../common/Tables/DataTable";
import { fetchZones, fetchRoles, fetchQlUsersByZone } from "../../services/api";

const ManageQAs = () => {
  const { callApi } = useApiCall();
  const [open, setOpen] = useState(false);
  const [qaList, setQAList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modelType, setModelType] = useState(null);
  const [deleteData, setDeleteData] = useState({});
  const [fetchRefresh, setFetchRefresh] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedZone, setSelectedZone] = useState(null);
  const [selectedQaLead, setSelectedQaLead] = useState(null);

  const [formData, setFormData] = useState({
    id: null,
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    password: "",
    mobile_number: "",
    profile_photo: null,
    status: "active",
    role_id: null,
    write_permission: false,
    read_permission: false,
  });
  const toast = useToast();
  const expireToken = useExpiredToken();
  const token = useSelector((state) => state.auth.jwtToken);
  const { searchText } = useSelector((state) => state.search);
  const [zones, setZones] = useState([]);
  const [roles, setRoles] = useState([]);
  const [tempQaLeads, setTempQaLeads] = useState([]);
  const loggedInRole = useSelector((state) => state.auth.role);
  const loggedInUserId = useSelector((state) => state.auth.userId);
  const loggedInZoneId = useSelector((state) => state.auth.zone);

  const normalizeRoleName = (name = "") =>name.replace(/_/g, "").toLowerCase(); 
  const filteredRoles = roles.filter((role) => {
    const roleKey = normalizeRoleName(role.name);

    // Quality Lead → ONLY QA
    if (loggedInRole === roleNames.qualityLead) {
      return roleKey === roleNames.qa;
    }
    // QA → QA + Quality Lead
    if (loggedInRole === roleNames.qualityAssurance) {
      return (
        roleKey === roleNames.qa ||
        roleKey === roleNames.qualityLead
      );
    }
    // trainer → ONLY trainee
    if (loggedInRole === roleNames.trainer) {
      return roleKey === roleNames.trainee;
    }
    // traininglead → trainner + trainee
    if (loggedInRole === roleNames.traininglead) {
      return (
        roleKey === roleNames.trainee ||
        roleKey === roleNames.trainer
      );
    }
    // Super Admin / Admin → ALL
    return true;
  });
  const handleEditUser = (record) => {
    setDeleteData(record?.originalItem);
    setIsModalOpen(true);
  };

  const showLoading = async (record = null) => {
    if (record) {
      const nameParts = record.full_name?.trim().split(" ") || [];
      const firstName = nameParts[0] || "";
      const lastName = nameParts.slice(1).join(" ") || "";
      setFormData({
        id: record.id,
        username: record.username,
        email: record.email,
        password: record.password,
        profile_photo: record.profile_photo,
        mobile_number: record.mobile_number,
        status: record.status ? "active" : "inactive",
        is_active: record.status ? 1 : 0,
        role_id: record.role_id,
        firstName: firstName,
        lastName: lastName,
        zone: record.zone || null,
        qa_lead_id: record.alloted_to || null,
        write_permission: record.write_permission || false,
        read_permission: record.read_permission || false, 
      });
    }
    setOpen(true);
  };

  const fetchAllQA = async () => {
    const res = await getApi("superadmin/users/qa/dynamic", token, expireToken);
    const data = await processEncryptedResponse(res);
    if (data) {
      setQAList(data);
    }
  };

  const handleDelete = async () => {
    let id = deleteData?.id;
    // const res = await deleteApi(`superadmin/users/qa/dynamic/${id}`, token, expireToken);
    const { status } = await callApi({
      endpoint: `superadmin/users/qa/dynamic/${id}`,
      apiMethod: "delete",
    });
    if (status) {
      setIsModalOpen(false);
      // fetchAllQA();
      setFetchRefresh((prev) => !prev);
    }
  };

  const handleCancel = () => {
    setOpen(false);
    setIsModalOpen(false);
    setSelectedZone(null); 
    setSelectedRole(null);
    setFormData({
      id: null,
      firstName: "",
      lastName: "",
      username: "",
      email: "",
      password: "",
      mobile_number: "",
      profile_photo: null,
      status: "active",
      role_id: roleIds.qa,
    });
  };

  const mappedData = qaList?.users?.map((item, i) => ({
    key: item.id,
    Name: item.full_name || null,
    Email: item.email || null,
    mobile_number: item.mobile_number || null,
    username: item.username || null,
    created_at: formatDate(item.created_at) || null,
    updated_at: formatDate(item.updated_at) || null,
    Status: item.status ? "Connected" : "Disconnected",
    Action: "View",
    originalItem: item,
  }));

  const filteredData = filterDataFunc(mappedData, searchText);

  // useEffect(() => {
  //   fetchAllQA();
  // }, []);

  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        // Fetch zones
        const zonesRes = await fetchZones(token, expireToken);

        // Check if response is an array or has {status, data} structure
        if (Array.isArray(zonesRes)) {
          setZones(zonesRes);
        } else if (zonesRes?.status) {
          setZones(zonesRes.data || []);
        } else {
          setZones([]);
        }


        // Fetch roles
        const rolesRes = await fetchRoles(token, expireToken);

        if (Array.isArray(rolesRes)) {
          setRoles(rolesRes);
        } else if (rolesRes?.status) {
          setRoles(rolesRes.data || []);
        } else {
          setRoles([]);
        }


      } catch (error) {
        console.error("Error fetching master data:", error);
      }
    };

    fetchMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    if (!selectedZone) {
      setTempQaLeads([]);
      return;
    }

    let isCancelled = false;

    const fetchQaLeads = async () => {
      try {
        const res = await fetchQlUsersByZone(selectedZone, selectedRole, token, expireToken);

        if (isCancelled) return;

        // Handle both array and {status, data} response
        const qaLeads = Array.isArray(res)
          ? res
          : res?.status
          ? Array.isArray(res.data)
            ? res.data
            : []
          : [];

        setTempQaLeads(qaLeads);

        // Only reset selected QA Lead if it is not valid
        setSelectedQaLead((prev) => {
          // If editing and formData has a qa_lead_id in this zone, keep it
          if (formData?.qa_lead_id && qaLeads.some((l) => l.userId === formData.qa_lead_id)) {
            return formData.qa_lead_id;
          }
          // Otherwise reset
          return null;
        });
      } catch (error) {
        if (!isCancelled) {
          console.error("Error fetching QA Leads for zone:", error);
          setTempQaLeads([]);
        }
      }
    };

    fetchQaLeads();

    return () => {
      isCancelled = true;
    };
    // Only run when selectedZone changes
  }, [selectedZone]);


    const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleStatusChange = (newStatus) => {
    setFormData((prev) => ({
      ...prev,
      status: newStatus,
      is_active: newStatus === "active" ? 1 : 0,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let res = null;
    let data = {
      username: formData.username,
      email: formData.email,
      password: formData.password,
      profile_photo: formData.profile_photo,
      mobile_number: formData.mobile_number,
      status: formData.status == "active" ? true : false,
      is_active: formData.is_active, 
      role_id: formData.role_id,
      zone: selectedZone || null,
      alloted_to: formData.qa_lead_id || selectedQaLead,
      full_name: [formData.firstName, formData.lastName].join(" "),
      write_permission: formData.write_permission,
      read_permission: formData.read_permission,
    };

    if (formData.id) {
      res = await assignPatch(
        `superadmin/users/qa/dynamic/${formData.id}`,
        token,
        { action: "UPDATE", ...data },
        expireToken,
        toast
      );
    } else {
      res = await assignPost("superadmin/users/qa/dynamic", token, data, expireToken, toast);
    }

    if (res?.status === 200 || res?.status === 201) {
      // toast.success(res?.data?.message);
      // fetchAllQA();
      setFetchRefresh((prev) => !prev);
      setFormData({
        id: null,
        firstName: "",
        lastName: "",
        username: "",
        email: "",
        password: "",
        mobile_number: "",
        profile_photo: null,
        status: "active",
        role_id: null,
        write_permission: false,
        read_permission: false,
      });
      setSelectedZone(null);
      setSelectedQaLead(null);
      setOpen(false);
    } else {
      // toast.error(res?.data?.data?.error);
    }
  };

  return (
    <>
      <>
        <div className="container-fluid">
          {/* <div className="">
                <FilterSection />
              </div> */}
          <DataTable
            updatedColumns={getManageQaTableColumns(showLoading, setModelType, handleEditUser)}
            // filteredData={filteredData}
            callApiArgs={{
              endpoint: "superadmin/users/qa/dynamic",
              accessorKey: "users",
            }}
            tableConfig={{
              dataMapper: (item, i) => ({
                key: item.id,
                Name: item.full_name || null,
                Email: item.email || null,
                mobile_number: item.mobile_number || null,
                username: item.username || null,
                created_at: formatDate(item.created_at) || null,
                updated_at: formatDate(item.updated_at) || null,
                Status: item.status ? "Connected" : "Disconnected",
                Action: "View",
                originalItem: item,
              }),
            }}
            emptyText={
              <>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ height: "90vh" }}
                >
                  <div className="d-flex flex-column">
                    <div className="">
                      <img src="../../../../assets/manage-call-logo.png" alt="manage-calls" />
                    </div>
                    <div className="d-flex flex-column text-center">
                      <p
                        style={{
                          color: "#052659",
                          textAlign: "center",
                          fontFamily: "Gilroy-Bold",
                          fontSize: "24px",
                          fontWeight: "400",
                        }}
                      >
                        {" "}
                        No QA Analysts Added Yet
                      </p>
                      <p
                        style={{
                          color: "#6B6B6B",
                          fontFamily: "Gilroy-Medium",
                          fontSize: "16px",
                        }}
                      >
                        {" "}
                        You need at least one QA to assign call recordings.
                      </p>
                      <p
                        style={{
                          color: "#6B6B6B",
                          fontFamily: "Gilroy-Medium",
                          fontSize: "16px",
                        }}
                        className="my-2"
                      >
                        {" "}
                        Please add a QA analyst to continue
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-center mt-4">
                      <Button
                        type="primary"
                        style={{
                          width: "auto",
                          background: "#052659",
                          color: "#FFFFFF",
                          fontSize: "18px",
                          fontFamily: "Gilroy-Bold",
                          borderRadius: "0px",
                          padding: "20px",
                        }}
                        icon={<PlusOutlined />}
                        onClick={() => {
                          setModelType("add");
                          showLoading();
                        }}
                      >
                        Add Users
                      </Button>
                    </div>
                  </div>
                </div>
              </>
            }
          />
        </div>
        <QAModel
          handleCancel={handleCancel}
          mode={modelType}
          showLoading={showLoading}
          open={open}
          formData={formData}
          handleInputChange={handleInputChange}
          handleSubmit={handleSubmit}
          handleStatusChange={handleStatusChange}
          selectedRole={selectedRole}
          setSelectedRole={setSelectedRole}
          roles={filteredRoles}
          selectedZone={selectedZone}
          setSelectedZone={setSelectedZone}
          zones={zones}
          selectedQaLead={selectedQaLead}
          setSelectedQaLead={setSelectedQaLead}
          loggedInUserId={loggedInUserId}
          loggedInRole={loggedInRole}
          loggedInZoneId={loggedInZoneId}
          tempQaLeads={Array.isArray(tempQaLeads) ? tempQaLeads : []}
        />
        <DeleteModal
          handleCancel={handleCancel}
          open={isModalOpen}
          handleDelete={handleDelete}
          title={"Are you sure you want to delete this user?"}
          description={
            "This action is permanent and cannot be undone. The user will lose all access to the platform and associated data will be removed."
          }
          width={700}
        />
        <div className="fixed-button-wrapper">
          <Button
            type="primary"
            style={{
              width: "auto",
              background: "#052659",
              color: "#FFFFFF",
              fontSize: "18px",
              fontFamily: "Gilroy-Bold",
              borderRadius: "0px",
              padding: "20px",
            }}
            icon={<PlusOutlined />}
            onClick={() => {
              setModelType("add");
              showLoading();
            }}
          >
            Add Users
          </Button>
        </div>
      </>
    </>
  );
};

export default ManageQAs;
